import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ServiceProviderService } from '../../../../core/services/service-provider.service';
import { ServiceProviderInterface } from '../../../../core/interfaces/service-provider.interface';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs/Subscription';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-service-provider',
  templateUrl: './service-provider.component.html',
  styleUrls: ['./service-provider.component.scss']
})
export class ServiceProviderComponent implements OnInit, OnDestroy {
  @ViewChild('cardServiceProvider') cardServiceProvider: T2CardComponent;
  @ViewChild('modalMergeServiceProvider') modalMergeServiceProvider: T2CardComponent;
  serviceproviderid: number;
  subsctriptions: Subscription[] = [];
  isActiveMerge = false;
  cardTitle: string;
  lastServiceProvId: any;

  constructor(
    private serviceProviderService: ServiceProviderService,
    private sweetAlertHelper: SweetAlertHelper,
    private loading: T2LoadingService
  ) {
    this.subsctriptions.push(
      this.serviceProviderService.serviceProviders$.subscribe((value) => {
        this.isActiveMerge = value.length > 1;
      }),
      this.serviceProviderService.closeModalMergeServiProviders$.subscribe((value) => {
        if (value.isClose) {
          if (this.modalMergeServiceProvider) {
            this.modalMergeServiceProvider.close();
          }
        }
      }),
      this.serviceProviderService.closeModalMergeServiProviders$.subscribe((value) => {
        if (value.isClose) {
          if (this.cardServiceProvider) {
            this.cardServiceProvider.close();
          }
        }
      }),
    );
  }

  ngOnInit() {
    this.listenDataServiceProvider();
    this.subsctriptions.push(
      this.serviceProviderService.newServiceProvider$.subscribe((resp: boolean) => {
        if (resp === false) {
          this.cardServiceProvider.close();
        }
      })
    );
    this.cardServiceProvider.close();
  }

  addServiceProvider() {
    this.cardTitle = 'Add New Service Provider';
    this.serviceProviderService.newServiceProvider$.emit(true);
    this.serviceProviderService.serviceProviderSelected$.emit(<ServiceProviderInterface>{ serviceproviderid: undefined });
    this.openCard();
  }

  /**@name openCard
   * @description Muestra el Form si esta oculto
   */
  openCard() {
    if (!this.cardServiceProvider.isOpen) {
      this.cardServiceProvider.open();
    }
  }

  /**@name listenDataServiceProvider
   * @description Escuha los cambios de la data
   */
  listenDataServiceProvider() {
    this.serviceProviderService.serviceProvId$.subscribe((data: any) => {
        if (data) {
          this.loading.show();
          this.subsctriptions.push(
          this.serviceProviderService.getById(data)
          .pipe(finalize(() => this.loading.hiden()))
          .subscribe({
            next: (provider: ServiceProviderInterface) => {
              if (provider && provider.description) {
                this.openCard();
                this.serviceproviderid = data;
                this.cardTitle = 'Edit Service Provider: ' + provider.description;
                this.serviceProviderService.nextDataServiceProvider(provider);
              }
            },
            error: (error) => {
              this.sweetAlertHelper.captureException(error);
            }
          }));
        } else {
          this.serviceproviderid = undefined;
          this.cardServiceProvider.close();
        }
      }
    );
  }

  onDeleteServiceProvider() {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure?',
      text: 'You want to permanently delete the selected element?',
      type: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'No',
      cancelButtonText: 'Yes'
    }).then((result) => {
      if (result.dismiss === swal.DismissReason.cancel) {
        this.serviceProviderService.deleteProviderService(this.serviceproviderid).subscribe((resp: any) => {
          if (resp.success) {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Deleted!',
              text: 'The element has been deleted.',
              type: 'success',
            }).then(() => {
              this.serviceProviderService.saveOnSuccessfull$.emit(true);
              this.serviceProviderService.serviceProviderSelected$.emit(<ServiceProviderInterface>{ serviceproviderid: undefined });
              this.cardServiceProvider.close();
            });
          }
        });
      }
    });
  }

  resetMergeServiceProvider(event: any) {
    if (!event.isOpen) {
      this.serviceProviderService.setResetMergeSelection();
    }
  }

  getServiceProviderIds() {
    if (this.modalMergeServiceProvider) {
      this.modalMergeServiceProvider.open();
    }
  }

  get isSelectedProvider() {
    return this.serviceproviderid ? true : false;
  }

  ngOnDestroy(): void {
    this.subsctriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/components/service-provider/service-provider.component.ts